// extracted by mini-css-extract-plugin
module.exports = {"select":"LanguagePicker-module--select--364N3"};